import { __require as requireObjectifier } from "./objectifier.js";
var processResult;
var hasRequiredProcessResult;
function requireProcessResult() {
  if (hasRequiredProcessResult) return processResult;
  hasRequiredProcessResult = 1;
  let objectify = requireObjectifier();
  processResult = function processResult2(result) {
    if (console && console.warn) {
      result.warnings().forEach((warn) => {
        let source = warn.plugin || "PostCSS";
        console.warn(source + ": " + warn.text);
      });
    }
    return objectify(result.root);
  };
  return processResult;
}
export {
  requireProcessResult as __require
};
//# sourceMappingURL=process-result.js.map
